import { Mutator } from 'final-form';

export const setFieldValue: Mutator = (args, state, tools) => {
    const [name, data] = args
    const field = state.fields[name]

    if (field) {
        tools.changeValue(state, name, () => data);
    }
}